import { render } from "./ResultTable.vue?vue&type=template&id=60855c56&scoped=true"
import script from "./ResultTable.vue?vue&type=script&lang=js"
export * from "./ResultTable.vue?vue&type=script&lang=js"

import "./ResultTable.vue?vue&type=style&index=0&id=60855c56&scoped=true&lang=css"

import exportComponent from "/home/syhpoon/UNIX/wealthpic/js/wealthpic-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60855c56"]])

export default __exports__